export const SESSION_MS = 6 * 60 * 60 * 1000;

export function touchSession() {
  localStorage.setItem("bet_session_at", String(Date.now()));
}

export function ensureSessionMark() {
  if (!localStorage.getItem("bet_session_at")) touchSession();
}

export function clearSessionMark() {
  localStorage.removeItem("bet_session_at");
}

export function sessionExpired() {
  const stamp = Number(localStorage.getItem("bet_session_at") || 0);
  if (!stamp) return false;
  return Date.now() - stamp > SESSION_MS;
}

export function tokenExpired(token) {
  if (!token) return true;
  const ttl = tokenTtlMs(token);
  if (ttl == null) return false;
  return ttl <= 0;
}

export function tokenTtlMs(token) {
  if (!token) return 0;
  try {
    const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    if (!payload.exp) return null;
    return payload.exp * 1000 - Date.now();
  } catch {
    return null;
  }
}

export function sessionRemainingMs() {
  const stamp = Number(localStorage.getItem("bet_session_at") || 0);
  if (!stamp) return SESSION_MS;
  return Math.max(0, SESSION_MS - (Date.now() - stamp));
}

export function isPlayPath(path = typeof window !== "undefined" ? window.location.pathname : "") {
  return /^\/(play|oyun)(\/|$)/.test(String(path || ""));
}
